import axios from "axios";
import { getApiBase } from "../apiBase";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = {};
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

export async function fetchExpansionSegmentFinancials(base) {
  const woBase = String(base || "").trim();
  const { data } = await axios.get(
    `${getApiBase()}/expansion/segments/${encodeURIComponent(woBase)}/financials`,
    { headers: authHeaders() }
  );
  return data;
}

/** All segment stored financials keyed by parent work order. */
export async function fetchAllExpansionSegmentFinancials() {
  const { data } = await axios.get(`${getApiBase()}/expansion/segments/financials`, {
    headers: authHeaders(),
  });
  return data && typeof data === "object" ? data : {};
}

export async function putExpansionSegmentFinancials(base, body) {
  const woBase = String(base || "").trim();
  const { data } = await axios.put(
    `${getApiBase()}/expansion/segments/${encodeURIComponent(woBase)}/financials`,
    body,
    { headers: authHeaders() }
  );
  return data;
}
